import React, { useState } from 'react';
import { handleReactivateSubscription } from '../../common/subscription/SubscriptionService';
import {
  Stack,
  Typography,
  CircularProgress,
  Box,
  Button,
  Paper,
} from '@mui/material';
import { styled } from '@mui/system';
import { showSuccessSnackbar } from '../../common/snackbar/SnackbarActions';
import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { selectSubscription } from '../../common/subscription/SubscriptionSlice';
import { useSelector } from 'react-redux';
import { formatDate } from '../../common/utils/formatFunctions';

const Item = styled(Paper)(({ theme }) => ({
  boxShadow: 'none',
  borderRadius: 0,
  margin: theme.spacing(0.5),
}));

const LeftItem = styled(Paper)(({ theme }) => ({
  boxShadow: 'none',
  borderRadius: 0,
  margin: theme.spacing(0.5),
  width: '98%',
  textAlign: 'left',
}));

export default function ReactivateSubscriptionForm({ callback = () => {} }) {
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const subscriptionInfo = useSelector(selectSubscription);

  const confirmButtonClick = () => {
    setIsSubmitting(true);
    handleReactivateSubscription()
      .then(() => {
        showSuccessSnackbar('Your subscription has been reactivated');
        setIsSubmitting(false);
        callback();
      })
      .catch((err) => {
        console.error(err);
        setErrorMessage(err.message);
        setIsSubmitting(false);
      });
  };

  return (
    <Stack alignItems='center' justifyContent='center'>
      <LeftItem>
        <Typography>
          <QuestionMarkIcon
            sx={{ color: 'primary.main' }}
            style={{ verticalAlign: 'middle' }}
          />
          Please confirm that you would like to reactivate your subscription.
          Payments per the terms of your plan will resume at your next billing
          date.
        </Typography>
      </LeftItem>

      <LeftItem>
        <Typography>
          <b>Plan: {subscriptionInfo.SubscriptionPlanName}</b> <br />
          {subscriptionInfo.PlanDescription}
        </Typography>
      </LeftItem>
      <LeftItem>
        <Typography>
          <b>Price</b>
          <br />
          {subscriptionInfo.SubscriptionCurrency === 'USD' ? '$' : ''}
          {subscriptionInfo.SubscriptionUnitPrice.toFixed(2)}{' '}
          {subscriptionInfo.SubscriptionCurrency}
        </Typography>
      </LeftItem>
      <LeftItem>
        <Typography>
          <b>Next Billing Date</b>
          <br />
          {formatDate(subscriptionInfo.SubscriptionCurrentPeriodEndsAt)}
        </Typography>
      </LeftItem>
      {errorMessage && (
        <LeftItem>
          <Typography sx={{ color: 'error.main' }}>{errorMessage}</Typography>
        </LeftItem>
      )}
      <Item>
        <Box sx={{ m: 1, position: 'relative' }}>
          <Button
            disabled={isSubmitting}
            variant='contained'
            onClick={confirmButtonClick}
          >
            <SaveIcon style={{ marginRight: '5' }} />
            Confirm
          </Button>
          {isSubmitting && (
            <CircularProgress
              size={24}
              sx={{
                color: 'secondary.main',
                position: 'absolute',
                top: '50%',
                left: '50%',
                marginTop: '-9px',
                marginLeft: '-12px',
              }}
            />
          )}
        </Box>
        <Button
          type={'reset'}
          color='secondary'
          disabled={isSubmitting}
          variant='contained'
          onClick={callback}
        >
          <CancelIcon style={{ marginRight: '5' }} />
          Back
        </Button>
      </Item>
    </Stack>
  );
}
